import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, HostBinding, Input, OnInit } from '@angular/core';
import { getHeroVirtualLevel } from '@helpers/data-helper';
import { LifeChancesComponent } from '@shared/components/life-chances/life-chances.component';

@Component({
  selector: 'app-avatar',
  standalone: true,
  templateUrl: './avatar.component.html',
  styleUrls: ['./avatar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgClass, LifeChancesComponent],
  host: {
    class: 'g-flex-column g-flex--align-center',
  },
})
export class AvatarComponent implements OnInit {
  @Input() avatarType: 'default' | 'boss' | 'small' | 'medium' | 'micro' | 'tiny' | 'reinforcement' = 'default';
  @Input() imagePath: string;
  @Input() isCenteredImage = false;
  @Input() ngLevel: number = 0;
  @Input() level: number = 0;
  @Input() experience: number = 0;
  @Input() levelToRight: boolean = false;
  @Input() isAbleLevelUp: boolean = false;
  @Input() lifeChances: number = -1;

  @HostBinding('class')
  get hostTypeClass() {
    return this.avatarType;
  }

  avatarPath: string = 'assets/images/ui/frames/avatar';
  isShowVirtualLevel: boolean = false;

  protected readonly getHeroVirtualLevel = getHeroVirtualLevel;

  ngOnInit() {
    switch (this.avatarType) {
      case 'default':
        this.avatarPath = `${this.avatarPath}/avatar-huge.avif`;
        break;

      case 'boss':
        this.avatarPath = `${this.avatarPath}/boss.avif`;
        break;

      case 'small':
        this.avatarPath = `${this.avatarPath}${this.ngLevel > 0 ? '/ng' : ''}/avatar-small${
          this.ngLevel > 0 ? '-' + this.ngLevel : ''
        }.avif`;
        break;

      case 'tiny':
        this.avatarPath = `${this.avatarPath}${this.ngLevel > 0 ? '/ng' : ''}/avatar-tiny${
          this.ngLevel > 0 ? '-' + this.ngLevel : ''
        }.avif`;
        break;

      case 'medium':
        this.avatarPath = `${this.avatarPath}/avatar.avif`;
        break;

      case 'micro':
        this.avatarPath = `${this.avatarPath}/avatar-small.avif`;
        break;

      case 'reinforcement':
        this.avatarPath = `${this.avatarPath}/avatar-reinforcement.avif`;
        break;
    }
  }

  switchLevel(event: MouseEvent): void {
    event.stopPropagation();
    event.preventDefault();

    this.isShowVirtualLevel = !this.isShowVirtualLevel;
  }
}
